import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { bindActionCreators } from 'redux';
import classnames from 'classnames';
import { withRouter } from 'react-router';
import {envProtocol, isOuterClick} from '../../utils';
import { PortalConfigContext } from '../../config/portal';
import { getLanguage, getCountry, getCurrentLocale, geti18nLocations } from '../../utils/language';
import { setGenericEvent } from '../../store/actions/dataLayer';
import './styles.css';

export class LanguagePicker extends PureComponent {
  state = {
    open: false,
  }

  containerRef = React.createRef();

  handleDocumentClick = (e) => {
    if (isOuterClick(e.target, this.containerRef.current)) {
      this.setState({ open: false });
    }
  }

  componentDidMount() {
    document.addEventListener('click', this.handleDocumentClick);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleDocumentClick);
  }

  toggle = () => {
    this.setState(prevState => ({
      open: !prevState.open
    }));
  }

  trackGenericClick = (event) => () => {
    this.props.setGenericEvent('top navbar', event.action, event.label);
  }

  render() {
    const { open } = this.state;
    const { pathname } = this.props.location;
    const locale = getCurrentLocale();
    const context =  get(this, 'context');
    const languages = get(context, 'languages');
    const hideCurrentLanguage = get(context, 'supports.hideCurrentLanguage', false);
    const currentLanguage = {
      language: locale,
      country: languages[locale].country,
    };
    const pickerFlag = currentLanguage.country;
    const pickerText = `${getCountry(currentLanguage.country)} (${getLanguage(currentLanguage.language)}) ▼`;
    const usesOldHeader = get(context, 'supports.oldHeader');
    const headerClassnames = classnames('lang-wrapper', {'new-header': !usesOldHeader});
    const hideClassname = open ? '' : 'lang-menu-hide';
    const fixedPathname = pathname.endsWith('/') ? pathname : pathname + '/';
    const localizedLocation = geti18nLocations(fixedPathname);
    return (
      <div
        ref={this.containerRef}
        onClick={this.toggle}
        className={headerClassnames}
      >
        <div
          className="lang-switcher"
        >
          <div
            className={`flag ${pickerFlag}`}
          />
          <span>
            {pickerText}
          </span>
        </div>
        <div
          className={`lang-menu ${hideClassname}`}
        >
          {localizedLocation.map(lang => {
            const { country } = languages[lang.lang];
            let url = envProtocol(lang.route);
            if (!hideCurrentLanguage || currentLanguage.language !== lang.lang){
              return (
                <a
                  href={url}
                  key={lang.lang}
                  onClick={this.trackGenericClick({action: 'country change', label: `${country}`})}
                  className="lang-item">
                  <div
                    className={`flag ${country}`}
                  />
                  {` ${getCountry(country)} - ${getLanguage(lang.lang)}`}
                </a>
              );
            }
          })}
        </div>
      </div>
    );
  }
}

LanguagePicker.propTypes = {
  currentLanguage: PropTypes.shape({
    country: PropTypes.string,
    language: PropTypes.string,
    url: PropTypes.string,
  }),
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
  setGenericEvent: PropTypes.func.isRequired,
};

LanguagePicker.contextType = PortalConfigContext;

export default withRouter(connect(
  null,
  (dispatch) => bindActionCreators({
    setGenericEvent
  }, dispatch)
)(injectIntl(LanguagePicker)));
